import { helperServices } from "../../shared/helper";
import history from "../../shared/utils/history";
import { apiFetch } from "../../shared/helper/apiFetch";

const basePath = "/api";

// -------------------- Logout --------------------
function logout() {
  localStorage.removeItem("user");
  localStorage.removeItem("token");
  history.push("/");
  window.location.reload();
}

// -------------------- Handle Response --------------------
function handleResponse(response) {
  return response.text().then((text) => {
    const data = text ? JSON.parse(text) : null;
    const token = response.headers.get("Authorization");

    if (token) {
      localStorage.setItem("token", JSON.stringify(token));
    }

    if (!response.ok) {
      if (response.status === 401) {
        logout();
      }
      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
}

// -------------------- Build Headers --------------------
function buildHeaders() {
  const accessToken = helperServices.getAuthorization() || "";

  return {
    Accept: "application/json",
    "Content-Type": "application/json",
    Authorization: accessToken,
  };
}

// -------------------- Get Doctors --------------------
function getDoctors() {
  const requestOptions = {
    method: "GET",
    headers: buildHeaders(),
  };

  const url = `${basePath}/doctors?limit=100`;
  return apiFetch(url, requestOptions);
}

// -------------------- Get Rooms --------------------
function getRooms() {
  const requestOptions = {
    method: "GET",
    headers: buildHeaders(),
  };

  const url = `${basePath}/rooms`;
  return apiFetch(url, requestOptions);
}

// -------------------- Get Sessions --------------------
function getSessions(params) {
  const requestOptions = {
    method: "GET",
    headers: buildHeaders(),
  };

  const url = `${basePath}/dashboard/sessions?${params}`;
  return apiFetch(url, requestOptions);
}

// -------------------- Export --------------------
const calendarServices = {
  logout,
  handleResponse,
  getDoctors,
  getRooms,
  getSessions,
};

export default calendarServices;